import { useEvolveChassisMutation, useEvolveWeaponMutation } from '@http';
import { capitalize } from '@helpers/dotNotation';
import { Button } from '@components/ui/Button';
import { useTranslation } from 'react-i18next';
import { Modal } from '@components/ui/Modal';
import { useAppStore } from '@stores';
import { useState } from 'react';

interface UpgradePrestigeProps {
  id: string;
  open: boolean;
  type: 'chassis' | 'weapon';
  onClose: () => void;
}

export function UpgradePrestige({ id, open, type, onClose }: UpgradePrestigeProps) {
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation(undefined, { keyPrefix: 'Upgrade' });
  const { mutateAsync: evolveChassis } = useEvolveChassisMutation();
  const { mutateAsync: evolveWeapon } = useEvolveWeaponMutation();
  const { refetch } = useAppStore();

  const prestige = async () => {
    if (loading) return;

    setLoading(true);

    if (type === 'chassis') {
      await evolveChassis({ id });
    } else {
      await evolveWeapon({ id });
    }

    refetch();
    onClose();
    setLoading(false);
  };

  return (
    <Modal title={t('prestigeModal')} onRequestClose={onClose} isOpen={open}>
      <div className="pt-4 px-2 text-shield text-center text-sm">
        <p>{t(`prestige${capitalize(type)}`)}</p>
      </div>

      <Button className="mt-4 border-0 border-t-1" onClick={prestige}>
        {t('prestige')}
      </Button>
    </Modal>
  );
}